module.exports = __webpack_public_path__ + "img/mandiri.e6551b88.png";